/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "contestAPI",
            "endpoint": "https://s9jeuvsze7.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:3ecaffe5-fc6b-40bc-ac4c-424be0739be7",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_6DL2pABxd",
    "aws_user_pools_web_client_id": "397viaa4rsmr7p8lmkgmi9bjlp",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "Dev_Contest-Collection",
            "region": "us-east-1"
        }
    ],
    "aws_user_files_s3_bucket": "test-contests",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
